import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./Firebase";

const functions = getFunctions(firebaseApp, "asia-south1");

export type PublicContactSubmission = {
    name: string;
    email: string;
    subject: string;
    message: string;
    sourcePage: string;
    website?: string;
};

export async function submitPublicContactMessage(data: PublicContactSubmission) {
    const result = await httpsCallable<PublicContactSubmission, { ok: true; messageId: string }>(functions, "submitPublicContactMessage")(data);
    return result.data;
}
